import React from 'react';
import { HelpIcon } from '@minna-technologies/minna-ui/icons/Help';
import { useFaqDialog } from '@client/modules/Faq/FaqHelpCenter/useFaqDialog';
import styles from './styles.scss';

export interface HelpIconWithFaqDialogProps {
  iconColor?: string;
  iconMarginRight?: number | string;
  dataTest?: string;
}

export const HelpIconWithFaqDialog: React.FC<HelpIconWithFaqDialogProps> = ({
  iconColor = 'rgb(0, 181, 185)',
  iconMarginRight = 0,
  dataTest = 'navbar-faq-button',
}) => {
  const [showFaq, faqDialog] = useFaqDialog();
  return (
    <>
      <button
        type="button"
        onClick={showFaq}
        className={styles.helpIconButton}
        data-test={dataTest}
        aria-label="Open FAQ dialog"
      >
        <HelpIcon style={{ color: iconColor, marginRight: iconMarginRight }} />
      </button>
      {faqDialog}
    </>
  );
};
